'use client'
const SECURE_ENCLAVE_WALLET_SESSION_KEYS = 'dynamic_secure_enclave_session_keys';

export { SECURE_ENCLAVE_WALLET_SESSION_KEYS };
